module.exports = __webpack_public_path__ + "img/d200911-1.51c24f04.jpg";